import React from 'react'
import ReactDOM from 'react-dom'
import WelcomeModal from '../Login/Modules/WelcomeModal.jsx'
import AlertBanner from './AlertBanner.jsx'
import TimeoutBanner from './TimeoutBanner.jsx'

export function showAlertBanner({
  nodeId,
  status,
  title,
  text,
  sticky,
  displayTime,
}) {
  nodeId = nodeId || 'popup' + Math.ceil(Math.random() * 1000000)

  const node = document.createElement('div')
  node.id = nodeId
  const alertBannerNode = document.getElementById('alert-banner')

  alertBannerNode.appendChild(node)
  ReactDOM.render(
    <AlertBanner
      status={status}
      title={title}
      text={text}
      sticky={sticky}
      displayTime={displayTime}
    />,
    document.getElementById(nodeId)
  )
}

export function showWelcomeBanner({ mode, profileData }) {
  const nodeId = 'popup' + Math.ceil(Math.random() * 1000000)

  const node = document.createElement('div')
  node.id = nodeId
  const alertBannerNode = document.getElementById('alert-banner')

  alertBannerNode.appendChild(node)
  ReactDOM.render(
    <WelcomeModal mode={mode} profileData={profileData} />,
    document.getElementById(nodeId)
  )
}

const timeoutNodeId = 'popup' + Math.ceil(Math.random() * 1000000)
export function showTimeoutBanner(
  durationInMinutes,
  closedClicked,
  onTimeComplete
) {
  const node = document.createElement('div')
  node.id = timeoutNodeId
  const alertBannerNode = document.getElementById('alert-banner')

  alertBannerNode.appendChild(node)
  ReactDOM.render(
    <TimeoutBanner
      durationInMinutes={durationInMinutes}
      closeClicked={closedClicked}
      onTimeComplete={onTimeComplete}
    />,
    document.getElementById(timeoutNodeId)
  )
}

export function removeTimeoutBanner() {
  ReactDOM.unmountComponentAtNode(document.getElementById(timeoutNodeId))
}
